import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import TextInput from '../../../components/TextInput';
import Form from '../../../components/Form';
import Button from '../../../components/Button';
import { formikSubmitDisabled } from '../../../lib/utils';
import { StyledText } from '../../../components/StyledText';

interface ReferralExpectationEditProps {
  referralExpectation: string
  open: boolean
  handleClose: () => void
  handleSubmit: (values: any) => void
}

const validationSchema = Yup.object().shape({
  referralExpectation: Yup.string().typeError('Required').required().trim()
});

const EditReferralExpectation: React.FC<ReferralExpectationEditProps> = ({
  open,
  handleClose,
  handleSubmit,
  referralExpectation
}) => {
  const formik = useFormik({
    initialValues: { referralExpectation },
    validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: true
  });

  const handleCancel = () => {
    handleClose();
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <Form formik={formik}>
        <DialogTitle disableTypography>
          <StyledText variant='h2'>Edit Referral Expectation</StyledText>
        </DialogTitle>
        <DialogContent>
          <TextInput
            type='text'
            minWidth='400px'
            multiline
            rows={10}
            id='referralExpectation'
            label='Expectation'
            placeholder=''
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancel}
            type='button'
            variant='text'
            size='large'
          >
            Cancel
          </Button>
          {formik.isSubmitting ? <CircularProgress color='secondary' style={{ width: 30, height: 30 }} />
            : (
              <Button
                type='submit'
                variant='contained'
                disableElevation
                color='primary'
                size='large'
                disabled={formikSubmitDisabled(formik)}
              >
                Update
              </Button>
            )}
        </DialogActions>
      </Form>
    </Dialog>
  );
};

export default EditReferralExpectation;
